// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"c4d5c46d","326":"e6ea4caf","787":"95b0c1cd"}[chunkId] + ".chunk.js";
};